import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { observer } from "mobx-react";
import { NakiNigunAlbumTrackProducerEditTemplate } from "themes/administration/naki-nigun/components";

// Reuses the naki-nigun producer editor UI; the injected view store applies changes to the staged
// import tree instead of persisting them directly.
const NakiNigunImportProducerEditModalTemplate = observer(function NakiNigunImportProducerEditModalTemplate({
    modalParams,
    t,
}) {
    return (
        <MrbModal
            modalParams={modalParams}
            t={t}
            className="modal__content modal__content--xlrg"
            shouldCloseOnOverlayClick={false}
        >
            {() =>
                modalParams.data && modalParams.data.producerEditViewStore ? (
                    <NakiNigunAlbumTrackProducerEditTemplate
                        nakiNigunAlbumTrackProducerEditViewStore={modalParams.data.producerEditViewStore}
                        closeModal={modalParams.close}
                        t={t}
                    />
                ) : null
            }
        </MrbModal>
    );
});

NakiNigunImportProducerEditModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default NakiNigunImportProducerEditModalTemplate;
